export interface DramaCharacter {
  name: string;
  actor: string;
  role: string;
  desc: string;
}

export interface DramaRelation {
  source: string;
  target: string;
  label: string;
}

export interface Drama {
  id: string;
  title: string;
  type: "电影" | "电视剧";
  year: number;
  rating: number;
  popularity: number;
  episodes: number;
  director: string;
  cast: string[];
  genre: string;
  tags: string[];
  summary: string;
  synopsis: string[];
  poster: string;
  backdrop: string;
  characters: DramaCharacter[];
  relations: DramaRelation[];
}

export const dramas: Drama[] = [
  {
    id: "d1",
    title: "出轨的妻子",
    type: "电视剧",
    year: 2024,
    rating: 8.6,
    popularity: 9860,
    episodes: 32,
    director: "陈砚秋",
    cast: ["林知夏", "顾维安", "苏曼", "周御衡"],
    genre: "家庭伦理",
    tags: ["家庭伦理", "情感剧", "婚姻", "女性成长"],
    summary:
      "一场看似平静的婚姻，因一次深夜未归的谎言而彻底失衡。全职主妇苏念在自我与家庭之间挣扎，丈夫的怀疑、旧友的归来与真相的层层剥落，让所有人被迫重新审视忠诚与原谅的边界。",
    synopsis: [
      "苏念与丈夫陆珩结婚七年，是旁人眼中可靠的模范夫妻。她辞去工作照顾家庭，把日子打理得井井有条，却在一次次被忽略的对话里，慢慢失去了自己的名字。",
      "一次加班后的深夜，陆珩发现妻子手机里那条没有备注的消息。怀疑像裂纹一样蔓延：她的沉默被解读为心虚，她的解释被当成借口。与此同时，大学时代的旧友江阔带着未说出口的往事重新出现，把苏念推到了所有目光的中央。",
      "剧集并不急于给任何人定罪，而是把镜头交给每一个被婚姻牵连的人——被误解的妻子、被隐瞒的丈夫、被卷入的孩子与朋友。当真相终于浮出水面，观众才发现真正被背叛的，或许不只是某一个人，而是所有人对彼此的那份信任。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20dramatic%20portrait%20of%20an%20elegant%20Chinese%20woman%20standing%20by%20a%20rain%20covered%20window%2C%20moody%20wine%20red%20and%20amber%20warm%20tones%2C%20film%20still%2C%20emotional%20soft%20shadows%2C%20no%20text&width=600&height=900&seq=chu-gui-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20night%20interior%20of%20an%20apartment%20with%20warm%20lamp%20light%20and%20rain%20on%20the%20glass%2C%20deep%20wine%20red%20and%20amber%20tones%2C%20tense%20atmosphere%2C%20film%20still%2C%20no%20text&width=1600&height=900&seq=chu-gui-bd-01&orientation=landscape",
    characters: [
      { name: "苏念", actor: "林知夏", role: "女主角 / 全职主妇", desc: "温柔克制，把家庭当成全部，却在被怀疑的时刻第一次想起自己是谁。" },
      { name: "陆珩", actor: "顾维安", role: "男主角 / 丈夫", desc: "理性强势的建筑师，习惯用掌控来确认安全感，直到发现掌控也会伤人。" },
      { name: "江阔", actor: "周御衡", role: "旧友 / 往事", desc: "大学时代的挚友，带着一段没说出口的往事归来，成为所有误会的引线。" },
      { name: "苏曼", actor: "苏曼", role: "妹妹 / 旁观者", desc: "唯一敢当面说真话的人，也是最早看清裂痕的人。" },
    ],
    relations: [
      { source: "苏念", target: "陆珩", label: "夫妻" },
      { source: "苏念", target: "江阔", label: "旧友 / 旧情?" },
      { source: "陆珩", target: "江阔", label: "猜忌" },
      { source: "苏念", target: "苏曼", label: "姐妹" },
      { source: "苏曼", target: "陆珩", label: "质疑" },
    ],
  },
  {
    id: "d2",
    title: "她背叛的那一夜",
    type: "电影",
    year: 2023,
    rating: 7.9,
    popularity: 7420,
    episodes: 0,
    director: "秦川",
    cast: ["许沐白", "沈星河", "叶清岚"],
    genre: "情感悬疑",
    tags: ["情感剧", "悬疑", "婚姻"],
    summary:
      "一个雨夜，一通无法解释的电话，把一段婚姻推向无法回头的十字路口。影片用倒叙揭开那一夜真正的样子。",
    synopsis: [
      "结婚五年的沈迟习惯用工作填满生活，直到那个雨夜妻子林晚没有回家。第二天清晨，她带着一身雨水出现在门口，只说了三个字：对不起。",
      "影片从这场沉默开始，用倒叙把观众带回完整的二十四小时。同样的对话在不同人口中呈现完全不同的版本，谁在说谎，谁在自欺，谁又只是记得了自己想记得的部分。",
      "当真相揭晓，那个‘背叛’的夜晚也许并不像任何人以为的样子，但信任的崩塌早已无法复原。电影最终没有审判，只留下雨停之后，两个人在客厅里久久没有说话的长镜头。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20style%20portrait%20of%20a%20woman%20in%20a%20dark%20coat%20under%20blurred%20city%20rain%20at%20night%2C%20deep%20crimson%20and%20warm%20ochre%20tones%2C%20moody%20mysterious%20lighting%2C%20no%20text&width=600&height=900&seq=chu-gui-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Rainy%20city%20street%20at%20night%20seen%20through%20wet%20glass%2C%20warm%20amber%20street%20lights%20and%20crimson%20reflections%2C%20cinematic%20moody%20film%20still%2C%20no%20text&width=1600&height=900&seq=chu-gui-bd-02&orientation=landscape",
    characters: [
      { name: "林晚", actor: "许沐白", role: "女主角", desc: "沉默寡言的设计师，那一夜的真相只有她自己知道。" },
      { name: "沈迟", actor: "沈星河", role: "男主角 / 丈夫", desc: "习惯回避问题的工程师，用忙碌掩盖了婚姻里真正的问题。" },
      { name: "叶清岚", actor: "叶清岚", role: "闺蜜", desc: "看似旁观，实则一直站在事件的中心。" },
    ],
    relations: [
      { source: "林晚", target: "沈迟", label: "夫妻" },
      { source: "林晚", target: "叶清岚", label: "闺蜜" },
      { source: "沈迟", target: "叶清岚", label: "询问真相" },
    ],
  },
  {
    id: "d3",
    title: "婚姻的裂缝",
    type: "电视剧",
    year: 2023,
    rating: 8.2,
    popularity: 8130,
    episodes: 28,
    director: "顾淮",
    cast: ["温以宁", "程叙", "孟娉婷"],
    genre: "家庭伦理",
    tags: ["家庭伦理", "都市", "婚姻", "女性成长"],
    summary:
      "一对从校服走到婚纱的夫妻，在柴米油盐里逐渐走散。裂缝从来不是一天形成的，修补也需要两个人一起。",
    synopsis: [
      "程叙与温以宁是朋友口中的‘模范夫妻’，从大学相恋到结婚生子，走过了所有人羡慕的十年。可只有他们自己知道，家里那张餐桌上有多少顿沉默的晚餐。",
      "当温以宁重新回到职场，她遇见了久违的自我，也遇见了婚姻里被搁置多年的问题。程叙则把注意力放在家庭之外的世界，以为只要不吵架，婚姻就没有问题。",
      "剧集用一季的时间，把一段关系如何一点点产生裂缝、又如何在裂缝里重新看见彼此，讲述得细腻克制。它问的不是谁对谁错，而是两个人是否还愿意为对方停下脚步。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20couple%20turned%20away%20from%20each%20other%20in%20a%20warm%20dim%20dining%20room%2C%20amber%20and%20muted%20maroon%20tones%2C%20melancholic%20film%20still%2C%20no%20text&width=600&height=900&seq=chu-gui-poster-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20empty%20family%20dining%20room%20at%20dusk%20with%20soft%20amber%20light%20and%20long%20shadows%2C%20cinematic%20melancholy%2C%20no%20text&width=1600&height=900&seq=chu-gui-bd-03&orientation=landscape",
    characters: [
      { name: "温以宁", actor: "温以宁", role: "女主角", desc: "为了家庭放下事业，又重新找回自己的人。" },
      { name: "程叙", actor: "程叙", role: "男主角", desc: "努力工作却忽略了伴侣感受的丈夫。" },
      { name: "孟娉婷", actor: "孟娉婷", role: "同事", desc: "职场上给予温以宁支持的伙伴，也照见了另一种选择。" },
    ],
    relations: [
      { source: "温以宁", target: "程叙", label: "夫妻" },
      { source: "温以宁", target: "孟娉婷", label: "同事 / 挚友" },
    ],
  },
  {
    id: "d4",
    title: "沉默的裂痕",
    type: "电影",
    year: 2022,
    rating: 7.5,
    popularity: 5210,
    episodes: 0,
    director: "林峙",
    cast: ["白榆", "简川"],
    genre: "文艺剧情",
    tags: ["文艺", "情感剧", "婚姻"],
    summary: "两个人在同一屋檐下生活，却隔着无法言说的沉默。一部关于沟通与孤独的安静电影。",
    synopsis: [
      "影片几乎没有激烈的争吵，却让人窒息。丈夫简川与妻子白榆在三天的时间里，用最普通的日常暴露了婚姻最深的裂缝。",
      "他们一起吃饭、一起收拾房间、一起看电视，可每一句话都像隔着一层玻璃。白榆把心事写进日记，简川把疲惫留在车里。",
      "电影相信沉默本身也是一种语言。当最后一个镜头定格在两人并肩而坐的背影上，观众听见的，是那些没有说出口的话。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Quiet%20cinematic%20portrait%20of%20a%20woman%20looking%20out%20a%20window%20at%20grey%20dusk%2C%20muted%20warm%20sepia%20and%20soft%20amber%20tones%2C%20art%20house%20film%20still%2C%20no%20text&width=600&height=900&seq=chu-gui-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Quiet%20minimalist%20apartment%20at%20dusk%20with%20warm%20low%20light%20and%20lonely%20silhouettes%2C%20muted%20amber%20and%20brown%20tones%2C%20art%20film%20still%2C%20no%20text&width=1600&height=900&seq=chu-gui-bd-04&orientation=landscape",
    characters: [
      { name: "白榆", actor: "白榆", role: "女主角", desc: "把情绪都藏起来的妻子，用日记对抗孤独。" },
      { name: "简川", actor: "简川", role: "男主角", desc: "沉默的丈夫，疲惫写在无人看见的地方。" },
    ],
    relations: [
      { source: "白榆", target: "简川", label: "夫妻 / 沉默" },
    ],
  },
  {
    id: "d5",
    title: "回不去的从前",
    type: "电视剧",
    year: 2024,
    rating: 8.0,
    popularity: 8010,
    episodes: 36,
    director: "苏晚",
    cast: ["江雨薇", "陆斯年", "宋一宁"],
    genre: "都市情感",
    tags: ["都市", "情感剧", "婚姻", "女性成长"],
    summary: "当旧爱的消息重新出现，一段已经平静的生活再次泛起涟漪。她们要面对的不是过去，而是现在的自己。",
    synopsis: [
      "江雨薇以为，结婚之后过去的那些事就真的过去了。直到某天，她收到了一条来自旧爱的消息，把一个尘封多年的名字重新带回生活。",
      "剧集围绕三个女性展开，她们拥有不同的婚姻，却都在问同一个问题：如果当初做了另一个选择，现在会更好吗？",
      "《回不去的从前》并不沉迷于怀旧，它更想说的，是人如何与自己的过去和解，并决定要不要继续向前走。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20cinematic%20portrait%20of%20a%20woman%20holding%20an%20old%20photograph%20near%20a%20sunlit%20window%2C%20amber%20and%20soft%20terracotta%20tones%2C%20emotional%20film%20still%2C%20no%20text&width=600&height=900&seq=chu-gui-poster-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Sunlit%20nostalgic%20room%20with%20old%20photographs%20and%20warm%20afternoon%20light%2C%20amber%20and%20terracotta%20tones%2C%20cinematic%20warmth%2C%20no%20text&width=1600&height=900&seq=chu-gui-bd-05&orientation=landscape",
    characters: [
      { name: "江雨薇", actor: "江雨薇", role: "女主角", desc: "看似安稳的妻子，被一条旧消息打乱了心绪。" },
      { name: "陆斯年", actor: "陆斯年", role: "男主人公", desc: "沉稳的伴侣，也有自己不愿提起的从前。" },
      { name: "宋一宁", actor: "宋一宁", role: "闺蜜", desc: "三个女性中最清醒也最脆弱的那一个。" },
    ],
    relations: [
      { source: "江雨薇", target: "陆斯年", label: "夫妻" },
      { source: "江雨薇", target: "宋一宁", label: "闺蜜" },
      { source: "宋一宁", target: "陆斯年", label: "旧识" },
    ],
  },
  {
    id: "d6",
    title: "第三个人",
    type: "电影",
    year: 2021,
    rating: 8.3,
    popularity: 6880,
    episodes: 0,
    director: "黎野",
    cast: ["秦昭", "何蔓", "沈鹿"],
    genre: "悬疑剧情",
    tags: ["悬疑", "婚姻", "复仇"],
    summary: "一段婚姻里出现的第三个人，究竟是谁？当真相被拼凑完整，所有人都成了故事的共犯。",
    synopsis: [
      "丈夫秦昭出差归来，发现家里多了一把陌生的伞。这把伞像一枚投入水面的石子，搅乱了原本平静的婚姻。",
      "影片用近乎冷酷的克制，一层层剥开三个人的关系。所谓的‘第三个人’，可能是一个具体的人，也可能只是婚姻里那道从未被填满的空缺。",
      "当真相揭开，观众会发现：故事里没有无辜者，每个人都有自己没说完的部分。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Dark%20cinematic%20noir%20portrait%20with%20three%20shadowed%20figures%20behind%20frosted%20glass%2C%20deep%20crimson%20and%20amber%20moody%20lighting%2C%20mysterious%20film%20still%2C%20no%20text&width=600&height=900&seq=chu-gui-poster-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dim%20noir%20hallway%20with%20a%20single%20warm%20lamp%20and%20long%20shadows%2C%20deep%20crimson%20accents%2C%20suspenseful%20cinematic%20film%20still%2C%20no%20text&width=1600&height=900&seq=chu-gui-bd-06&orientation=landscape",
    characters: [
      { name: "秦昭", actor: "秦昭", role: "男主角 / 丈夫", desc: "以理性调查一切的丈夫，却在调查里失去婚姻。" },
      { name: "何蔓", actor: "何蔓", role: "女主角 / 妻子", desc: "藏着太多秘密的妻子，每一个沉默都有代价。" },
    ],
    relations: [
      { source: "秦昭", target: "何蔓", label: "夫妻" },
      { source: "秦昭", target: "第三个人", label: "追查" },
    ],
  },
  {
    id: "d7",
    title: "午夜来电",
    type: "电视剧",
    year: 2022,
    rating: 7.7,
    popularity: 6100,
    episodes: 24,
    director: "方楠",
    cast: ["易澜", "崔铭", "夏栀"],
    genre: "都市悬疑",
    tags: ["悬疑", "都市", "婚姻"],
    summary: "每天午夜响起的陌生来电，把一个看似幸福的家庭拖入窥探与猜忌的漩涡。",
    synopsis: [
      "自从搬进新家，易澜总会在午夜接到一通没有声音的电话。起初她以为是恶作剧，直到电话那头开始说出只有她和丈夫知道的秘密。",
      "猜忌在两人之间发酵，谁在监视他们的生活，谁又在扮演受害者。随着调查深入，一个与家庭密切相关的旧秘密被重新翻出。",
      "《午夜来电》在悬疑外衣下，讲的是信任一旦出现第一个缺口，就很难再合上的故事。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20tense%20portrait%20of%20a%20woman%20holding%20a%20phone%20in%20the%20dark%2C%20glowing%20warm%20amber%20light%20on%20her%20face%2C%20deep%20crimson%20accents%2C%20suspense%20film%20still%2C%20no%20text&width=600&height=900&seq=chu-gui-poster-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dark%20apartment%20window%20at%20midnight%20with%20city%20lights%20beyond%2C%20warm%20amber%20glow%20and%20crimson%20hues%2C%20suspenseful%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=chu-gui-bd-07&orientation=landscape",
    characters: [
      { name: "易澜", actor: "易澜", role: "女主角", desc: "敏锐的妻子，执着于弄清午夜来电的来源。" },
      { name: "崔铭", actor: "崔铭", role: "男主角 / 丈夫", desc: "表面冷静，却藏着与新家有牵连的过去。" },
      { name: "夏栀", actor: "夏栀", role: "邻居", desc: "总是恰好出现的邻居，知道得比她说出口的多。" },
    ],
    relations: [
      { source: "易澜", target: "崔铭", label: "夫妻" },
      { source: "易澜", target: "夏栀", label: "邻居 / 试探" },
      { source: "崔铭", target: "夏栀", label: "秘密" },
    ],
  },
  {
    id: "d8",
    title: "原谅的边缘",
    type: "电影",
    year: 2024,
    rating: 7.8,
    popularity: 5980,
    episodes: 0,
    director: "沈知白",
    cast: ["阮清歌", "纪南舟"],
    genre: "剧情",
    tags: ["情感剧", "婚姻", "女性成长"],
    summary: "当背叛发生之后，原谅究竟是一种勇气还是一种妥协？一段修复之旅的完整记录。",
    synopsis: [
      "事情发生后，阮清歌没有立刻离开，也没有立刻原谅。她选择给彼此一段时间，去搞清楚那些年他们在婚姻里到底错过了什么。",
      "影片把镜头对准了‘之后’——不是撕裂的瞬间，而是漫长的、笨拙的、时而倒退的修复过程。两个人在咨询室里、在厨房里、在深夜的阳台上，一遍遍重新学习如何对话。",
      "《原谅的边缘》拒绝给出简单答案，它只是诚实地记录：原谅从来不是一次决定，而是一段路。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20gentle%20portrait%20of%20a%20woman%20in%20soft%20morning%20light%20looking%20calm%20and%20tired%2C%20warm%20amber%20and%20muted%20rose%20tones%2C%20emotional%20film%20still%2C%20no%20text&width=600&height=900&seq=chu-gui-poster-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Soft%20morning%20light%20in%20a%20minimal%20bedroom%20with%20sheer%20curtains%2C%20warm%20amber%20and%20cream%20tones%2C%20hopeful%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=chu-gui-bd-08&orientation=landscape",
    characters: [
      { name: "阮清歌", actor: "阮清歌", role: "女主角", desc: "选择留下来面对问题的妻子，坚强而克制。" },
      { name: "纪南舟", actor: "纪南舟", role: "男主角 / 丈夫", desc: "试图用行动弥补的丈夫，学会不再逃避。" },
    ],
    relations: [
      { source: "阮清歌", target: "纪南舟", label: "夫妻 / 修复中" },
    ],
  },
  {
    id: "d9",
    title: "红色婚戒",
    type: "电视剧",
    year: 2021,
    rating: 8.4,
    popularity: 8900,
    episodes: 40,
    director: "何砚",
    cast: ["余蔓青", "傅西洲", "唐梨"],
    genre: "家族伦理",
    tags: ["家庭伦理", "复仇", "婚姻", "家族"],
    summary: "一枚婚戒牵扯出两个家族数十年的恩怨。当真相被揭开，爱情与仇恨都无处躲藏。",
    synopsis: [
      "余蔓青嫁入傅家那天，戴上的不仅是一枚婚戒，也是一段被隐瞒多年的家族往事的开端。",
      "婚戒在剧中反复出现：它是承诺，是枷锁，也是两个家族之间未解恩怨的见证。随着蔓青逐渐接近真相，她发现自己的婚姻从一开始就被安排在别人的棋盘上。",
      "《红色婚戒》把情感与家族复仇交织在一起，讲述一个人在爱恨之间，如何找回属于自己的选择权。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Opulent%20cinematic%20portrait%20of%20a%20woman%20in%20an%20elegant%20dark%20gown%20holding%20up%20her%20hand%20with%20a%20ring%2C%20rich%20crimson%20and%20gold%20warm%20tones%2C%20dramatic%20lighting%2C%20no%20text&width=600&height=900&seq=chu-gui-poster-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Luxurious%20dim%20family%20mansion%20interior%20with%20warm%20gold%20and%20crimson%20tones%2C%20dramatic%20cinematic%20lighting%2C%20no%20text&width=1600&height=900&seq=chu-gui-bd-09&orientation=landscape",
    characters: [
      { name: "余蔓青", actor: "余蔓青", role: "女主角", desc: "嫁入豪门的新娘，在爱恨中找回主导权。" },
      { name: "傅西洲", actor: "傅西洲", role: "男主角 / 丈夫", desc: "背负家族秘密的继承人，爱与责任两难。" },
      { name: "唐梨", actor: "唐梨", role: "家族旧人", desc: "掌握真相却迟迟不肯开口的关键人物。" },
    ],
    relations: [
      { source: "余蔓青", target: "傅西洲", label: "夫妻" },
      { source: "傅西洲", target: "唐梨", label: "家族旧识" },
      { source: "余蔓青", target: "唐梨", label: "追问真相" },
    ],
  },
  {
    id: "d10",
    title: "她的秘密",
    type: "电影",
    year: 2023,
    rating: 8.1,
    popularity: 6640,
    episodes: 0,
    director: "顾南枝",
    cast: ["黎昭昭", "傅宴辞"],
    genre: "情感悬疑",
    tags: ["悬疑", "情感剧", "女性成长"],
    summary: "每个人都以为了解她，直到那个秘密被揭开。一部关于女性自我与选择的电影。",
    synopsis: [
      "在公司里，她是干练可靠的黎昭昭；在家里，她是体贴的妻子。没有人知道，她一直在秘密地准备着一件彻底改变人生的事。",
      "当秘密开始被身边的人察觉，误会与猜忌接踵而至。丈夫以为她要离开，朋友以为她在隐瞒，只有她自己知道，这个‘秘密’其实关乎她重新定义自己的勇气。",
      "电影最终讲述的不是背叛，而是一个人如何在被期待的角色之外，终于为自己活一次。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20a%20confident%20woman%20looking%20over%20her%20shoulder%20in%20warm%20side%20light%2C%20amber%20and%20deep%20rose%20tones%2C%20mysterious%20film%20still%2C%20no%20text&width=600&height=900&seq=chu-gui-poster-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Modern%20office%20at%20golden%20hour%20with%20warm%20amber%20light%20through%20tall%20windows%2C%20cinematic%20and%20warm%2C%20no%20text&width=1600&height=900&seq=chu-gui-bd-10&orientation=landscape",
    characters: [
      { name: "黎昭昭", actor: "黎昭昭", role: "女主角", desc: "在多个身份之间周旋，最终选择做自己的女人。" },
      { name: "傅宴辞", actor: "傅宴辞", role: "男主角 / 丈夫", desc: "敏感细腻的丈夫，误读了妻子的秘密。" },
    ],
    relations: [
      { source: "黎昭昭", target: "傅宴辞", label: "夫妻 / 误会" },
    ],
  },
  {
    id: "d11",
    title: "围城之下",
    type: "电视剧",
    year: 2024,
    rating: 8.5,
    popularity: 9240,
    episodes: 30,
    director: "谢长风",
    cast: ["顾念之", "裴之屿", "李婉"],
    genre: "都市伦理",
    tags: ["都市", "家庭伦理", "婚姻", "女性成长"],
    summary: "三个家庭，三段婚姻，在同一座城市里彼此映照。围城里的人，各有各的进退。",
    synopsis: [
      "同一栋写字楼里，三个家庭的命运交织在一起。有人刚结婚，有人正经历中年危机，有人已经在考虑离开。",
      "《围城之下》用群像的方式，讲述婚姻在不同阶段会遇到的困境：激情消退、经济压力、原生家庭、育儿分歧。没有绝对的对错，只有不同的选择与代价。",
      "剧集相信，理解比评判更有力量。当每个角色都走到了自己该走的位置，观众也会在其中某个瞬间，看见自己的影子。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20portrait%20of%20three%20Chinese%20women%20standing%20together%20in%20warm%20city%20evening%20light%2C%20amber%20and%20terracotta%20tones%2C%20emotional%20film%20still%2C%20no%20text&width=600&height=900&seq=chu-gui-poster-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20city%20skyline%20at%20dusk%20with%20glowing%20amber%20windows%2C%20cinematic%20urban%20mood%2C%20no%20text&width=1600&height=900&seq=chu-gui-bd-11&orientation=landscape",
    characters: [
      { name: "顾念之", actor: "顾念之", role: "女主角", desc: "新婚不久的妻子，正学着理解婚姻的分量。" },
      { name: "裴之屿", actor: "裴之屿", role: "男主角 / 丈夫", desc: "在事业与家庭之间寻找平衡的丈夫。" },
      { name: "李婉", actor: "李婉", role: "同事", desc: "看透婚姻却仍愿意相信爱情的旁观者。" },
    ],
    relations: [
      { source: "顾念之", target: "裴之屿", label: "夫妻" },
      { source: "顾念之", target: "李婉", label: "同事 / 挚友" },
      { source: "裴之屿", target: "李婉", label: "同事" },
    ],
  },
  {
    id: "d12",
    title: "二次告别",
    type: "电影",
    year: 2022,
    rating: 7.6,
    popularity: 4760,
    episodes: 0,
    director: "宋既明",
    cast: ["谢知遥", "顾寒声"],
    genre: "文艺剧情",
    tags: ["文艺", "情感剧", "婚姻"],
    summary: "有些人告别了两次，一次是身体离开，一次是终于放下。一部关于放手的温柔电影。",
    synopsis: [
      "离婚三年后，谢知遥和前夫顾寒声在一次偶然的场合重逢。两人客气地寒暄，仿佛从未共享过十年的生活。",
      "电影记录了他们重逢后的三天：整理旧物、处理共同的债务、以及一场迟到的、真正的告别。那些曾经无法说出口的话，终于在一切结束之后被轻轻说出。",
      "《二次告别》安静而克制，它讲述的不是重燃，而是学会真正地、完整地告别一个人。",
    ],
    poster:
      "https://readdy.ai/api/search-image?query=Melancholic%20cinematic%20portrait%20of%20a%20woman%20and%20man%20in%20a%20bright%20empty%20room%20moving%20boxes%2C%20warm%20muted%20amber%20and%20cream%20tones%2C%20quiet%20emotional%20film%20still%2C%20no%20text&width=600&height=900&seq=chu-gui-poster-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Bright%20empty%20apartment%20with%20half%20filled%20moving%20boxes%20and%20warm%20afternoon%20light%2C%20muted%20amber%20tones%2C%20quiet%20cinematic%20still%2C%20no%20text&width=1600&height=900&seq=chu-gui-bd-12&orientation=landscape",
    characters: [
      { name: "谢知遥", actor: "谢知遥", role: "女主角", desc: "离婚三年后重逢前夫，完成真正的告别。" },
      { name: "顾寒声", actor: "顾寒声", role: "男主角 / 前夫", desc: "学会了尊重与放手的男人。" },
    ],
    relations: [
      { source: "谢知遥", target: "顾寒声", label: "前夫妻 / 告别" },
    ],
  },
];